import { render, staticRenderFns } from "./SukoyakasanLink.vue?vue&type=template&id=4d01a2dc&scoped=true&"
import script from "./SukoyakasanLink.vue?vue&type=script&lang=ts&"
export * from "./SukoyakasanLink.vue?vue&type=script&lang=ts&"
import style0 from "./SukoyakasanLink.vue?vue&type=style&index=0&id=4d01a2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d01a2dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSpacer})
